/**
 * Is same JSON?
 * @param  {JSON}
 * @param  {JSON}
 * @return {Boolean}
 */

export const isEqualJSON = (jsonFirst, jsonSecond) => (JSON.stringify(jsonFirst) === JSON.stringify(jsonSecond));
